import * as Types from 'server/api/types';
import { axiosRequestHelper, RequestHelperResult } from './endpoint-helpers';

export const getCurrentNotification = (): Promise<
    RequestHelperResult<Types.GetCurrentNotificationResponseBody['data']>
> => axiosRequestHelper<Types.GetCurrentNotificationResponseBody>('GET', '/api/notifications/current');
